import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { VISA_TYPE_ID } from "libs/configs/constant";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import CancelVisaService from "services/CancelVisaService";

let initialState = {
    step: '',
    showReqeustDoc: false,
    docRequests: [],
    smartDetail: null,
    partForm: [],
    currentDraftId: null,
    currentDraftDetail: null,
    oldData: null
};

export const getRequestDoc = createAsyncThunk(
    "statusReport/getRequestDoc",
    async (body) => {

        if (body.currSmartServiceId === VISA_TYPE_ID.SMART_T) {
            body.conditionType = 'T';
        }
        if (body.currSmartServiceId === VISA_TYPE_ID.SMART_I) {
            body.conditionType = 'I';
        }
        if (body.currSmartServiceId === VISA_TYPE_ID.SMART_S) {
            body.conditionType = 'S';
        }
        if (body.currSmartServiceId === VISA_TYPE_ID.SMART_E) {
            body.conditionType = 'E';
        }
        if (body.currSmartServiceId === VISA_TYPE_ID.SMART_O) {
            body.conditionType = 'O';
        }

        const response = await CancelVisaService.getCancelRequestDoc(body);
        const data = response?.results;
        data.forEach(d => {
            d.isRequired = d.blank;
        })

        // if (body.currSmartServiceId === VISA_TYPE_ID.SMART_T) {
        //     data.forEach(d => {
        //         d.isRequired = d.company;
        //     })
        // }
        // if (body.currSmartServiceId === VISA_TYPE_ID.SMART_I) {
        //     data.forEach(d => {
        //         d.isRequired = d.copy;
        //     })
        // }
        // if (body.currSmartServiceId === VISA_TYPE_ID.SMART_S) {
        //     data.forEach(d => {
        //         d.isRequired = d.c6M;
        //     })
        // }
        // if (body.currSmartServiceId === VISA_TYPE_ID.SMART_E || body.currSmartServiceId === VISA_TYPE_ID.SMART_O) {
        //     data.forEach(d => {
        //         d.isRequired = d.blank;
        //     })
        // }


        return response?.results;
    }
);


export const addSmartFromStatusReport = createAsyncThunk(
    "statusReport/addSmartFromStatusReport",
    async (body) => {
        const response = await CancelVisaService.addSmartFromStatusReport(body);
        return response?.results?.draftId;
    }
);

export const addPersonalStatusReport = createAsyncThunk(
    "statusReport/addPersonalStatusReport",
    async (body) => {
        const response = await CancelVisaService.addPersonalStatusReport(body);
        return response?.results;
    }
);



export const getSmartFormList = createAsyncThunk(
    "statusReport/getSmartFormList",
    async (body) => {
        const response = await CancelVisaService.getSmartFormList(body);
        return response?.results;
    }
);

export const getOldDataSmartFormList = createAsyncThunk(
    "statusReport/getOldDataSmartFormList",
    async (body) => {
        const response = await CancelVisaService.getSmartFormList(body);
        return response?.results;
    }
);




export const getPartFormList = createAsyncThunk(
    "statusReport/getPartFormList",
    async (body) => {
        const response = await CancelVisaService.getPartFormList(body);
        return response?.results;
    }
);



export const getSmartFormOld = createAsyncThunk(
    "statusReport/getSmartFormOld",
    async (body) => {
        const response = await CancelVisaService.getSmartFormOld(body);
        return response?.results;
    }
);




export const getPartFormDetail = createAsyncThunk(
    "statusReport/getPartFormDetail",
    async (body) => {
        const response = await CancelVisaService.getSmartFormList(body);
        return response?.results;
    }
);


// export const addSmartCancel = createAsyncThunk(
//     "statusReport/addSmartCancel",
//     async (draftId) => {
//         const response = await CancelVisaService.addSmartCancel(draftId);
//         return response?.results;
//     }
// );



const statusReportSlice = createSlice({
    name: "statusReport",
    initialState: initialState,
    reducers: {
        setStep: (state, action) => {
            state.step = action.payload
        },
        readRequestDoc: (state, action) => {
            state.showReqeustDoc = action.payload
        },
    },
    extraReducers: (builder) => {
        LoadingAdapter.applyAsyncBuilder(getRequestDoc, builder, ["docRequests"]);
        LoadingAdapter.applyAsyncBuilder(getSmartFormList, builder, ["smartDetail"]);
        LoadingAdapter.applyAsyncBuilder(getPartFormList, builder, ["partForm"]);
        LoadingAdapter.applyAsyncBuilder(getSmartFormOld, builder, ["oldData"]);
        LoadingAdapter.applyAsyncBuilder(addSmartFromStatusReport, builder, ["currentDraftId"]);
        LoadingAdapter.applyAsyncBuilder(getPartFormDetail, builder, ["currentDraftDetail"]);
        LoadingAdapter.applyAsyncBuilder(getOldDataSmartFormList, builder, ["oldData"]);

    },
});

export const { setStep, readRequestDoc } = statusReportSlice.actions

export default statusReportSlice.reducer;


export const selectRequestDocs = (state) => {

    const { docRequests } = state.statusReport;
    let group = docRequests.reduce((r, a) => {
        r[a.typeDocumentName] = [...r[a.typeDocumentName] || [], a];
        return r;
    }, {});

    return group;
};